import React from 'react';
import { DatePicker } from '../DatePicker/DatePicker';
import { Icons } from '../Icons/Icons';
import './DateRangePicker.scss';

interface DateRangePickerProps {
  startDate: Date | null;
  endDate: Date | null;
  onStartDateChange: (date: Date | null) => void;
  onEndDateChange: (date: Date | null) => void;
  onClearFilters?: () => void;
  minDate?: Date | null;
  maxDate?: Date | null;
  showClearButton?: boolean;
  className?: string;
}

export const DateRangePicker: React.FC<DateRangePickerProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onClearFilters,
  minDate,
  maxDate,
  showClearButton = false,
  className = '',
}) => {
  return (
    <div className={`date-filters ${className}`}>
      <div className="date-label">From</div>
      <DatePicker
        id="date-range-start-date"
        name="startDate"
        label=""
        value={startDate}
        onChange={onStartDateChange}
        minDate={minDate}
        maxDate={endDate || maxDate}
      />
      <div className="date-label">To</div>
      <DatePicker
        id="date-range-end-date"
        name="endDate"
        label=""
        value={endDate}
        onChange={onEndDateChange}
        minDate={startDate || minDate}
        maxDate={maxDate}
      />
      {showClearButton && onClearFilters && (
        <div className="clear-filter" onClick={onClearFilters}>
          {Icons.Close}
          Reset Filters
        </div>
      )}
    </div>
  );
};
